// extracted by mini-css-extract-plugin
module.exports = {"head":"_9OZQu","hide_tabletLarge":"T7CKO","heading":"ytgRk","block":"j3GBg"};